import Vue from 'vue';
import vueResource from 'vue-resource';
import ProtocalError from './protocalError';

Vue.use(vueResource);
Vue.http.options.emulateJSON = true;
Vue.http.headers.common['version'] = 'yunst';
function _POST ({ commit }, url = '', params = {}) {
  return Vue.http.post(url, params).then((res) => {
    const json = res.json();

    if (res.status === 200 || (res.status === 302 && json.status !== 403)) {    // HTML Status
      return json;  //  返回数据
    } else {
      return Promise.reject(res);
    }
  }).catch((res) => {
    if (res.status === 302 || res.status === 0) {
      commit('HAS_LOGGED_OUT');
    }
    return Promise.reject(res);
  });
}

function emptyParamsFilter (source) {
  if (typeof source === 'object') {
    let o = {};
    for (let i in source) {
      if (typeof source[i] !== 'undefined' && source[i] !== null && source[i] !== '') {
        o[i] = source[i];
      };
    }
    return o;
  } else {
    return source;
  }
}

const protocalPrefix = '';

const POST = function ({ dispatch, commit }, _url = '', _params = {}, emptyAllow = false) {
  const url = protocalPrefix + _url;
  const params = emptyAllow ? _params : emptyParamsFilter(_params);

  return _POST({ dispatch, commit }, url, params).then(({ data, code, msg }) => { // Protocal Status
    if (code === 1001) {
      return data;
    } else if (code === 41009) {  // 未登陆
      commit('HAS_LOGGED_OUT');
      return Promise.reject(new ProtocalError(code, '用户未登陆或会话已超时'));
    } else if (code === 45109) {
      return Promise.reject(new ProtocalError(code, '无可用的结算钱包'));
    } else if (code === 45104) {
      return Promise.reject(new ProtocalError(code, '收款账号未设置结算绑定账号'));
    } else {
      return Promise.reject(new ProtocalError(code, msg, data));
    }
  }).catch((res) => {
    return res.data ? Promise.reject(res.data) : Promise.reject(res);
  });
};

export default POST;